import {useEffect} from "react";
import ToastStyles from './Toast.module.scss';
import {ToastProps} from "../../entity/index.entity";

const Toast = ({ message, onClose, status }: ToastProps) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`${ToastStyles.toast} ${ToastStyles[status]}`}>
            {message}
        </div>
    );
};

export default Toast